import { get, put, del } from './client';

export const listarPosicoes = () => get('/geolocalizacao');
export const compartilharPosicao = (payload) => put('/geolocalizacao', payload);
export const pararCompartilhamento = () => del('/geolocalizacao');
